import { ieee, mla, mla7, mla8 } from './styleConstants'

export const citeTextList = [
  ['ieee-access', 'reprinted work'],
  ['ieee-access', 'digital file'],
  ['ieee-access', 'journal'],
  ['ieee-asme-transactions-on-mechatronics', 'bible'],
  ['ieee-asme-transactions-on-mechatronics', 'journal'],
  ['ieee-transactions-on-power-systems', 'website'],
  [ieee, 'conference'],
  [ieee, 'dictionary'],
  [ieee, 'dissertation abstract'],
  [ieee, 'editorial'],
  [ieee, 'government publication'],
  [ieee, 'journal'],
  [ieee, 'map'],
  [ieee, 'report'],
  [ieee, 'software'],
  [ieee, 'website'],
  [mla8, 'cartoon'],
  [mla8, 'reprinted work'],
  [mla8, 'congress'],
  [mla8, 'dictionary'],
  [mla8, 'digital file'],
  [mla8, 'government publication'],
  [mla8, 'interview'],
  [mla8, 'journal'],
  [mla8, 'lecture'],
  [mla8, 'letter'],
  [mla8, 'map'],
  [mla8, 'music'],
  [mla8, 'newsgroup'],
  [mla8, 'painting'],
  [mla8, 'report'],
  [mla, 'blogs'],
  [mla, 'conference'],
  [mla, 'dissertation abstract'],
  [mla, 'journal'],
  [mla, 'software'],
  [mla, 'website'],
  [mla7, 'bible'],
  [mla7, 'congress'],
  [mla7, 'dictionary'],
  [mla7, 'dissertation'],
  [mla7, 'editorial'],
  [mla7, 'government publication'],
  [mla7, 'manuscript'],
  [mla7, 'map'],
  [mla7, 'newsgroup'],
  [mla7, 'newsletter'],
  [mla7, 'newspaper'],
  [mla7, 'software'],
  [mla7, 'website'],
]

export const citeTextDesc = (style: string, source: string): string => {
  return `Cite ${source} effortlessly in ${style} format with Citation Machine. Properly credit your sources and generate accurate citations for professional projects. `
}
